import "./EditSiteInformation.html";
import "./EditSiteInformation.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditSiteInformationComponentController from "./EditSiteInformationComponentController";

export default class EditSiteInformationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditSiteInformationComponentController;
        this.templateUrl = "/App/Components/Site/Overview/SiteInformation/EditSiteInformation/EditSiteInformation.html";
    }
}

module("mmManagePortal").component("mmEditSiteInformation", new EditSiteInformationComponent());
